module.exports = __webpack_public_path__ + "img/1500490230.04dbbd53.jpg";